import { Injectable } from '@angular/core';
import { Make3cxCallRequest, Make3cxCallResponse } from 'src/lib/fliko/models/http/threeCx.data';
import { FunctionsApiService } from 'src/app/shared/services/functions-api.service';

@Injectable({ providedIn: 'root' })
export class ThreeCxService {
  constructor(private functionsApi: FunctionsApiService) {}

  public makeCall(request: Make3cxCallRequest): Promise<Make3cxCallResponse> {
    return this.functionsApi.callFunctionOrThrow<Make3cxCallRequest, Make3cxCallResponse>('make3cxCall', request);
  }
}
